// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'snippets/collection-driver/collection-driver';

import 'sections/page-header/page-header';
import 'sections/footer/footer';
import 'sections/country-modal/country-modal';
import 'sections/fitment-collection/fitment-collection';


// Styles
import './_collection.scss';